<template>
    <div ref="container">
       <a-modal 
        :title="title" 
        width="95%" 
        :visible="visible" 
        :confirmLoading="confirmLoading" 
        :maskStyle="{'top':'93px','left':'154px'}" 
        :maskClosable="false" 
        @ok="handleOk" 
        @cancel="handleCancel"
        @closeModal="closeModal" 
        cancelText="关闭" 
        style="top:50px;height: 90%;"
        :footer="null"
        >
           <process ref="processDialog"></process>
        </a-modal>
    </div>
</template>
<script>
// import pick from 'lodash.pick'
import process from '../process.vue';
import { traceModuleEdit, traceModuleDetail } from '@/api/api'
export default {
  name: 'CustomerModal',
  components: {
    process
  },
  data () {
    return {
      title: '工序列表',
      visible: false, 
      confirmLoading: false,
      traceVueModule: null,
      form: this.$form.createForm(this),
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
      },
      formModule:[],
      traceModuleForm: {},
      getRuleIdFromFather: '',
      getProcessId: null,
      getCraftId: null,
    }
  },
    methods: {
        open(data){
            this.visible = true
            this.getRuleIdFromFather = data.codeRuleId
            this.getCraftId = data.craftId
            this.getProcessId = data.processId
            console.log(data,'获取的data==============')
        },
        show(data){
            console.log(data,'获取的data==============')
            this.visible = true
        },
        add(data) {
          this.traceModuleForm = data
          this.visible = true;
          this.$nextTick(() => {
            if (this.$refs.traceModules && typeof this.$refs.traceModules.showDialog === 'function') {
              this.$refs.traceModules.showDialog(data);
            } else {
              console.error('traceModules 或 showDialog 未正确初始化');
            }
          });
          this.getFormArray(data)
        },
        // 获取表单数据
        async getFormArray(data){
          const res = await traceModuleDetail(data)
          if( res.code == 200 && res.success == true ){
              this.formModule = res.result.formArray
              this.traceVueModule = res.result.formArray
          }
        },
        handleGetDrawingList(drawingList){
          // 在这里处理接收到的 drawingList 数据
          this.formModule = drawingList
        },
        handleOk() {

          this.visible = false;
        },
        handleCancel(){
          console.log('父组件被调用了==========================')
          this.visible = false;
          this.resetCurrentStepInChild();
        },
        closeModal(){
          
          this.visible = false;
        },
        resetCurrentStepInChild() {
          if (this.$refs.traceCode) {
            this.$refs.traceCode.resetCurrentStep();
          }
        }
    }
}
</script>
<style lang="less" scoped>

</style>